<template>
  <GravManagerWrapper :id="id" :componentName="componentName" :properties="filteredProps">
    <component :is="FrontlineTable" v-bind="{ style: $attrs.style, ...changableProps }">
      <template v-for="slotName in Object.keys($slots)" #[slotName]="slotProps">
        <slot :name="slotName" v-bind="slotProps" />
      </template>
    </component>
  </GravManagerWrapper>
</template>

<script setup lang="ts">
import { FrontlineTableProps } from './FrontlineTable.ts';
import FrontlineTable from './FrontlineTable.vue';
import GravManagerWrapper from './GravManagerWrapper.vue';

import { useChangableProps } from '@/composables/useChangableProps';
import { computed } from 'vue';

const componentName = 'ui-frontline-table';
const $slots = defineSlots<Record<string, unknown>>();

const props = defineProps<FrontlineTableProps>();
const filteredProps = computed(() => {
  const properties = props.properties.filter((prop) => prop);

  return {
    ...props,
    properties,
  };
});

const changableProps = useChangableProps(componentName, filteredProps.value);
</script>
